// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__114KO","image":"Header_image__5jPu2","name":"Header_name__K30Eh","info":"Header_info__3qx8h","infoRow":"Header_infoRow__TV_xq"};